import styles from './index.less';
import icon_right from "../../../asset/img/login/icon_right.png";
import { onClickhref } from 'utils';

const Blank = ({ children, title, moreUrl, className }: any) => {
  return <div className={`${className} ${styles.blank}`}>
    <div
      className={styles.top}
      data-a-nofollow="true"
      onClick={() => {
        onClickhref(moreUrl);
      }}
    >
      <div className={styles.topText}>
        {title}
      </div>
      {moreUrl && <div className={styles.topMore}>
        <span>
          查看全部
        </span>
        <img src={icon_right} alt="" />
      </div>
      }
    </div>
  {children}
</div>
}

export default Blank;